(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-rm-nav]:not([data-ready])').forEach(nav => {
      nav.dataset.ready = 'true';
      const mobile = nav.classList.contains('rm-mobile-links');
      const desktop = matchMedia('(min-width: 1200px)');
      const hover = matchMedia('(hover: hover)');
      const items = [...nav.querySelectorAll('[data-rm-item]')];
      let active = null;
      let closeTimer;
      const close = () => {
        clearTimeout(closeTimer);
        if (!active) return;
        active.querySelector('.rm-mega').hidden = true;
        active.querySelector('button').setAttribute('aria-expanded', 'false');
        delete active.dataset.open;
        active = null;
      };
      const open = item => {
        clearTimeout(closeTimer);
        if ((!mobile && !desktop.matches) || active === item) return;
        close();
        active = item;
        item.dataset.open = '';
        item.querySelector('.rm-mega').hidden = false;
        item.querySelector('button').setAttribute('aria-expanded', 'true');
      };
      items.forEach(item => {
        const button = item.querySelector('button');
        item.addEventListener('pointerenter', event => {
          if (!mobile && hover.matches && event.pointerType !== 'touch') open(item);
        });
        button.addEventListener('click', event => {
          if (!mobile && event.detail > 0 && hover.matches) open(item);
          else active === item ? close() : open(item);
        });
        item.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown' && !event.target.closest('.rm-mega')) {
            event.preventDefault();
            open(item);
            item.querySelector('.rm-mega a')?.focus();
          }
        });
      });
      nav.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      nav.addEventListener('pointerleave', () => {
        if (!mobile) closeTimer = setTimeout(close, 160);
      });
      nav.addEventListener('focusout', event => {
        if (!mobile && !nav.contains(event.relatedTarget)) close();
      });
      nav.addEventListener('focusin', event => {
        if (!mobile && active && !active.contains(event.target)) close();
      });
      nav.addEventListener('keydown', event => {
        if (event.key === 'Escape' && active) {
          event.preventDefault();
          event.stopPropagation();
          active.querySelector('button').focus();
          close();
        }
      });
      nav.querySelectorAll('.rm-nav-item:not([data-rm-item])').forEach(item => {
        if (!mobile) {
          item.addEventListener('pointerenter', close);
          item.addEventListener('focusin', close);
        }
      });
      document.addEventListener('click', event => { if (!nav.contains(event.target)) close(); });
      desktop.addEventListener('change', close);
      if (mobile) nav.closest('[data-rm-mobile]').addEventListener('toggle', event => {
        if (!event.target.open) close();
      });
    });
    root.querySelectorAll('[data-rm-mobile]:not([data-ready])').forEach(menu => {
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(menu.open)));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; summary.focus(); }
      });
      document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
      matchMedia('(min-width: 1200px)').addEventListener('change', () => { menu.open = false; });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
